import _ from 'lodash';
// @mui
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
//components
import { useTheme, List } from '@mui/material';
import FormItem from './FormItem';
import { FormInputsTypes } from 'constants/settings.constants';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';

export interface radioProps {
	handleChange: any;
	options: { value: any; label: string }[];
	value: any;
	label: string;
}

export type formItemType = {
	icon: any;
	text: string;
	type: FormInputsTypes;
	disable?: boolean;
};

export type formItemsType = {
	title: string;
	contents: formItemType[];
};

export default function FormItems(props: { item: formItemsType; handleEdit: any; editButtonLabelPrefix?: string }) {
	const theme = useTheme();
	const { item, handleEdit, editButtonLabelPrefix } = props;
	const t = useAppSelector(selectTranslations);
	return (
		<FormControl
			fullWidth
			sx={{
				display: 'flex',
				justifyContent: 'space-between',
			}}
		>
			<FormLabel
				sx={{
					letterSpacing: 0,
					fontWeight: 600,
					color: theme.palette.root.ux07777,
					fontSize: '12px',
					lineHeight: '14px',
				}}
			>
				{item.title}
			</FormLabel>
			<List sx={{ marginBottom: '32px' }}>
				{item.contents.map((content, index) => {
					return (
						<FormItem
							key={index}
							content={content}
							handleEdit={handleEdit}
							editButtonLabel={t(editButtonLabelPrefix + _.snakeCase(content.type) + '_edit_button.text')}
						/>
					);
				})}
			</List>
		</FormControl>
	);
}
